/* Name: PageLayout.jsx
* Copyright: (c) DA-Design Oy
* Creation date: 14.05.2024   (EKn)
* Modified: 07.11.2024        (PKo)
*
* Description:
*/

//import '../scss/style.scss'
import  React, { useState , useEffect } from 'react'
import { Box, Typography, AppBar, Toolbar, Stack } from '@mui/material';
import { SignInButton } from "./SignInButton";
import { SignOutButton } from "./SignOutButton";
import { Upload } from "../Upload";
import VRlogo from '../../images/bannerlogo.png';

const Bannerlogo = () => {
    return <img src={VRlogo} width="250px;" />
}

let user_role = import.meta.env.VITE_USER_ROLE;

/**
 * Renders the navbar component with a sign in (or sign out button) depending on whether or not a user is authenticated
 * @param props
 */
export const PageLayout = (props) => {

  const [userInfo, setUserInfo] = useState();

  if (userInfo) {
    console.log(userInfo.userRoles);
  }

  return (
    <>
      <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          {/* Top Menu Bar (Full Width) */}
          <Box sx={{ width: '100%' }}>
            <AppBar position="static" sx={{backgroundColor: 'rgb(0, 161, 73)'}}>
                <Toolbar>
                  <Bannerlogo/>
                </Toolbar>
            </AppBar>
          </Box>

          {/* Main Content Area */}
          <Box sx={{ flexGrow: 1, overflowY: 'auto', display: 'flex', justifyContent: 'center' }}>
            {!userInfo ? 
              <Stack spacing={2} sx={{ maxWidth: 600, width: '100%' }}>
                <SignInButton setUserInfo={setUserInfo} /> 
              </Stack>
            : 
              <Upload userInfo={userInfo}/>
            }
          </Box>

        {/* Footer with Text (Full Width) */}
        <Box component="footer" sx={{ width: '100%', p: 2, backgroundColor: 'rgb(0, 161, 73)', color: 'white', textAlign: 'center' }}>
          <Typography variant="body2">
            © 2024 DA-Group Oy. All rights reserved.
          </Typography>
          {userInfo ? <SignOutButton /> : null}
        </Box>
      </Box>
    </>
  );
};
